import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Programi() {
  const [t] = useTranslation();
  return (
    <>
      <section className="courses pt-120 pb-120 p-relative fix">
        <div className="animations-01">
          <img src="assets/img/bg/floating-logo.png" alt="floating-logo-fpep" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 p-relative">
              <div
                className="section-title center-align mb-50 wow fadeInDown animated"
                data-animation="fadeInDown"
                data-delay=".4s"
              >
                <h5>
                  <i className="fas fa-graduation-cap" />{" "}
                  {t("programs.studyprograms")}
                </h5>
                <h2>{t("programs.osnovne")}</h2>
              </div>
            </div>
          </div>
          <div className="row jsutify-content-center">
            <div className="col-lg-4 col-md-6 mb-4 d-flex align-items-stretch">
              <div className="courses-item hover-zoomin">
                <div className="thumb fix">
                  <Link to="/racunovodstvo-finansije-i-bankarstvo">
                    <img
                      src="/assets/img/bg/Fpep-01.png"
                      alt="racunovodstvo-finansije-i-bankarstvo-slika"
                    />
                  </Link>
                </div>
                <div className="courses-content">
                  <div className="cat">
                    <i className="fas fa-graduation-cap" />{" "}
                    {t("programs.osnovneCup")}
                  </div>
                  <h3>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      {t("osnovne.rfb")}
                    </Link>
                  </h3>
                  <p>
                    {t("programs.osnovneOpis")}
                    <br />
                    1. {t("rfb.modul1")}
                    <br />
                    2. {t("rfb.modul2")}
                    <br />
                    3. {t("rfb.modul3")}
                  </p>
                  <Link
                    to="/racunovodstvo-finansije-i-bankarstvo"
                    className="readmore"
                  >
                    {t("header.SaznajVise")}{" "}
                    <i className="fas fa-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 d-flex align-items-stretch">
              <div className="courses-item hover-zoomin">
                <div className="thumb fix">
                  <Link to="/menadzment">
                    <img
                      src="/assets/img/bg/Fpep-02.png"
                      alt="menadzment-slika"
                    />
                  </Link>
                </div>
                <div className="courses-content">
                  <div className="cat">
                    <i className="fas fa-graduation-cap" />{" "}
                    {t("programs.osnovneCup")}
                  </div>
                  <h3>
                    <Link to="/menadzment">{t("osnovne.menadzment")}</Link>
                  </h3>
                  <p>
                    {t("programs.osnovneOpis")}
                    <br />
                    1. {t("menadzment.modul1")}
                    <br />
                    2. {t("menadzment.modul2")}
                    <br />
                    3. {t("menadzment.modul3")}
                  </p>
                  <Link to="/menadzment" className="readmore">
                    {t("header.SaznajVise")}{" "}
                    <i className="fas fa-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 d-flex align-items-stretch">
              <div className="courses-item hover-zoomin">
                <div className="thumb fix">
                  <Link to="/pravo-osnovne">
                    <img
                      src="/assets/img/bg/Fpep-04.png"
                      alt="osnovne-pravo-slika"
                    />
                  </Link>
                </div>
                <div className="courses-content">
                  <div className="cat">
                    <i className="fas fa-graduation-cap" />{" "}
                    {t("programs.osnovneCup")}
                  </div>
                  <h3>
                    <Link to="/pravo-osnovne">{t("osnovne.pravo")}</Link>
                  </h3>
                  <p>
                    {t("programs.osnovneOpis")}
                    <br />
                    1. {t("pravo.modul1")}
                    <br />
                    2. {t("pravo.modul2")}
                    <br />
                    3. {t("pravo.modul3")}
                  </p>
                  <Link to="/pravo-osnovne" className="readmore">
                    {t("header.SaznajVise")}{" "}
                    <i className="fas fa-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="courses pb-120 p-relative fix">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 p-relative">
              <div
                className="section-title center-align mb-50 wow fadeInDown animated"
                data-animation="fadeInDown"
                data-delay=".4s"
              >
                <h2>{t("programs.specijalisticke")}</h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10 mb-4 d-flex align-items-stretch">
              <div className="courses-item hover-zoomin">
                <div className="thumb fix">
                  <Link to="/specijalisticke-studije">
                    <img
                      src="/assets/img/bg/Fpep-05.png"
                      alt="Specijalističke studije"
                    />
                  </Link>
                </div>
                <div className="courses-content">
                  <div className="cat">
                    <i className="fas fa-graduation-cap" />{" "}
                    {t("programs.specialistCup")}
                  </div>
                  <h3>
                    <Link to="/specijalisticke-studije">
                      {t("specialistNotice.title")}
                    </Link>
                  </h3>
                  <p>{t("specialistNotice.lead")}</p>

                  <Link to="/specijalisticke-studije" className="readmore">
                    {t("header.SaznajVise")} {" "}
                    <i className="fas fa-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="courses pb-120 p-relative fix">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 p-relative">
              <div
                className="section-title center-align mb-50 wow fadeInDown animated"
                data-animation="fadeInDown"
                data-delay=".4s"
              >
                <h2>{t("programs.master")}</h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6 mb-4 d-flex align-items-stretch">
              <div className="courses-item hover-zoomin">
                <div className="thumb fix">
                  <Link to="/poslovna-ekonomija">
                    <img
                      src="/assets/img/bg/Fpep-03.png"
                      alt="poslovna-ekonomija-slika"
                    />
                  </Link>
                </div>
                <div className="courses-content">
                  <div className="cat">
                    <i className="fas fa-graduation-cap" />{" "}
                    {t("programs.masterCup")}
                  </div>
                  <h3>
                    <Link to="/poslovna-ekonomija">
                      {t("master.poslovnaEkonomija")}
                    </Link>
                  </h3>
                  <p>{t("pe.opis")}</p>

                  <Link to="/poslovna-ekonomija" className="readmore">
                    {t("header.SaznajVise")}{" "}
                    <i className="fas fa-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 d-flex align-items-stretch">
              <div className="courses-item hover-zoomin">
                <div className="thumb fix">
                  <Link to="/ekonomija-javnog-sektora">
                    <img
                      src="/assets/img/bg/Fpep-05.png"
                      alt="ekonomija-javnog-sektora-slika"
                    />
                  </Link>
                </div>
                <div className="courses-content">
                  <div className="cat">
                    <i className="fas fa-graduation-cap" />{" "}
                    {t("programs.masterCup")}
                  </div>
                  <h3>
                    <Link to="/ekonomija-javnog-sektora">
                      {t("master.ekonomijaJavnogSektora")}
                    </Link>
                  </h3>
                  <p>{t("ejs.opis")}</p>

                  <Link to="/ekonomija-javnog-sektora" className="readmore">
                    {t("header.SaznajVise")}{" "}
                    <i className="fas fa-long-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 d-flex align-items-stretch">
              <div className="courses-item hover-zoomin">
                <div className="thumb fix">
                  <Link to="/pravo-master">
                    <img
                      src="/assets/img/bg/Fpep-04.png"
                      alt="master-pravo-slika"
                    />
                  </Link>
                </div>
                <div className="courses-content">
                  <div className="cat">
                    <i className="fas fa-graduation-cap" />{" "}
                    {t("programs.masterCup")}
                  </div>
                  <h3>
                    <Link to="/pravo-master">{t("master.pravo")}</Link>
                  </h3>
                  <p>{t("pravoMaster.opis")}</p>

                  <Link to="/pravo-master" className="readmore">
                    {t("header.SaznajVise")}{" "}
                    <i className="fas fa-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Programi;
